export function shuffledCopy<T>(items: readonly T[], random: () => number = Math.random): T[] {
  const shuffled = [...items]

  for (let current = shuffled.length - 1; current > 0; current -= 1) {
    const swapWith = Math.floor(random() * (current + 1))
    ;[shuffled[current], shuffled[swapWith]] = [shuffled[swapWith], shuffled[current]]
  }

  return shuffled
}
